import React, { Component } from 'react'

class ProjectBullets extends Component {
    render() {
        const { bullets } = this.props

        return (
            <div>
                <h4 className="gamma">The project at a glace...</h4>
                <div className="u-bullet-list" dangerouslySetInnerHTML={{ __html: bullets }}></div>
            </div>
        )
    }
}

export default ProjectBullets


// WEBPACK FOOTER //
// ./src/components/Project/ProjectBullets.js